import { Navigate, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { useUser } from '../../../redux/user/useUser';

import { LpAdHeader } from '../../organisms/lp/ad/LpAdHeader';
import { LpAdFv } from '../../organisms/lp/ad/LpAdFv';
import { LpAdSuccessStory } from '../../organisms/lp/ad/LpAdSuccessStory';
import { LpAdProgram } from '../../organisms/lp/ad/LpAdProgram';
import { LpFeature } from '../../organisms/lp/LpFeature';
import { LpAdLeadSimple } from '../../organisms/lp/ad/LpAdLeadSimple';
import { LpAdLesson } from '../../organisms/lp/ad/LpAdLesson';
import { LpAdProgramSampleList } from '../../organisms/lp/ad/LpAdProgramSampleList';
import { LpAdCareerSupport } from '../../organisms/lp/ad/LpAdCareerSupport';
import { LpAdQuestion } from '../../organisms/lp/ad/LpAdQuestion';
import { LpAdStudyFlow } from '../../organisms/lp/ad/LpAdStudyFlow';
import { LpAdRank } from '../../organisms/lp/ad/LpAdRank';
import { LpAdUserVoice } from '../../organisms/lp/ad/LpAdUserVoice';
import { LpAdPrice } from '../../organisms/lp/ad/LpAdPrice';
import { LpAdMedia } from '../../organisms/lp/ad/LpAdMedia';
import { LpAdGift } from '../../organisms/lp/ad/LpAdGift';
import { LpAdPlan } from '../../organisms/lp/ad/LpAdPlan';
import { LpAdLead } from '../../organisms/lp/ad/LpAdLead';
import { LpFooter } from '../../organisms/lp/LpFooter';
import { LpAdFloatBanner } from '../../organisms/lp/ad/LpAdFloatBanner';
import { LpAdPopup } from '../../organisms/lp/ad/LpAdPopup';
import { FunctionType, PermissionType } from '../../../const/UserPermission';
import { LpAdChallenge } from '../../organisms/lp/ad/LpAdChallenge';
import { sessionStorageSupport } from '../../../utils/sessionStorageSupport';
import { useGoogleFonts } from '../../../common/customHooks/GoogleFonts';
import { LpAdFaq } from '../../organisms/lp/ad/LpAdFaq';

export const LpAd: React.FC = () => {
  const { canAccess, cvLink } = useLpAd();

  return (
    <>
      {canAccess ? (
        <>
          <LpAdHeader onClickCV={cvLink} />
          <LpAdFv onClickCV={cvLink} />
          <LpAdSuccessStory />
          <LpAdProgram />
          <LpAdLeadSimple onClickCV={cvLink} />
          <LpFeature title={'サービスの特徴'} id="feature" dataE2e="feature" />
          <LpAdPrice />
          <LpAdLesson />
          <LpAdProgramSampleList />
          <LpAdChallenge />
          <LpAdCareerSupport />
          <LpAdQuestion />
          <LpAdStudyFlow />
          <LpAdRank onClickCV={cvLink} />
          <LpAdUserVoice />
          <LpAdGift />
          <LpAdPlan />
          <LpAdMedia />
          <LpAdLead onClickCV={cvLink} />
          <LpAdFaq />
          <LpFooter />
          <LpAdFloatBanner onClickCV={cvLink} />

          <LpAdPopup />
        </>
      ) : (
        <Navigate to="/home" replace />
      )}
    </>
  );
};

const useLpAd = () => {
  const { permissionCheck } = useUser();
  const location = useLocation();
  const navigate = useNavigate();
  useGoogleFonts();

  const query = queryString.parse(location.search);
  if (query.utm_source) {
    sessionStorageSupport.setItem('UTM_SOURCE', String(query.utm_source));
  }

  const cvLink = () => {
    navigate('/register');
  };

  const canAccess = permissionCheck(FunctionType.LP, PermissionType.Read);

  return { canAccess, cvLink };
};
